<!--
 * @Author: LiuChuanQi
 * @Date: 2022-11-28 17:07:39
 * @LastEditTime: 2023-03-03 10:28:14
 * @LastEditors: LiuChuanQi
 * @Description: 账号密码登录模式
 * @FilePath: \speedtest-bigdata-v2\src\components\common\login\PasswordType.vue
 *
-->
<template>
  <div class="password-type">
    <div class="input-item1">
      <input
        type="text"
        class="account"
        :class="{'error':accountMessage}"
        @blur="blurAccount"
        @input="accountInput"
        v-input
        v-model="account"
        placeholder="手机号/用户名/邮箱"
      >
      <div class="bottom-tip">{{accountMessage}}</div>
    </div>
    <div class="input-item2">
      <input
        type="password"
        class="account"
        :class="{'error':passwordMessage}"
        @blur="blurPassword"
        @input="passwordInput"
        v-input
        v-model="password"
        @paste="accountPaste"
        placeholder="密码"
      >
      <div class="bottom-tip">{{passwordMessage}}</div>
      <span
        class="reset-password"
        @click.stop="resetPassword"
      >忘记密码？</span>
    </div>
    <!-- <div class="login">登录</div> -->
    <waterproof
      :judgeFunction="judgeFunction"
      :showPlugin="showPlugin"
      class="login"
      :CaptchaAppId="waterKey"
      :callback="callback"
      title="登录"
      :options="{needFeedBack: false}"
    ></waterproof>
    <div class="register">
      <div @click.stop="toRegister">快速注册</div>
    </div>
    <div class="jg"></div>
    <div class="user-infor">
      <span
        class="check-box"
        :class="{ 'active': isAccept }"
        @click="toggleClick"
      ></span>
      <div class="infor-content">
        <p>
          阅读并同意
          <a
            class="heightLight"
            href="https://www.speedtest.cn/terms"
            target="_blank"
          >《用户协议》</a>、
          <a
            class="heightLight"
            href="http://www.speedtest.cn/privacy"
            target="_blank"
          >《隐私政策》</a>和
        </p>
        <p><a
            class="heightLight"
            href="http://www.speedtest.cn/promise"
            target="_blank"
          >《产品使用承诺书》</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { passwordLogin } from '@/api/login'
import store from '@/store/index'
import {waterKey} from '@/config/waterProofKey'
export default {
  props: {
    showRegister: {
      type: Boolean
    },
    loginScuess: {
      //是否登录成功
      type: Boolean
    },
    isShowInfor: {
      type: Boolean
    }
  },
  data() {
    return {
      accountMessage: '', //账号或密码错误提示信息
      passwordMessage: '', //密码错误提示信息
      account: '',
      password: '', //实际的密码
      pwd: '', //密码加密的*
      showPlugin: false, //控制防水墙弹窗
      isAccept: false, //使用同意用户协议
      waterKey
    }
  },
  methods: {
    //监听粘贴事件
    accountPaste() {
      //console.log(this.password)
      this.pwd = ''
      this.password = ''
    },
    toggleClick() {
      this.isAccept = !this.isAccept
    },
    //验证账号输入失去焦点
    blurAccount() {
      if (!this.account) {
        this.accountMessage = '请输入账号'
      } else if (this.account.length > 25) {
        this.accountMessage = '请输入正确的账号'
      } else {
        this.accountMessage = ''
      }
    },
    accountInput() {
      if (!this.account) {
        this.accountMessage = '请输入账号'
      } else if (this.account.length > 25) {
        this.accountMessage = '请输入正确的账号'
      } else {
        this.accountMessage = ''
      }
    },
    //密码框失去焦点校验
    blurPassword() {
      if (!this.password) {
        this.passwordMessage = '请输入密码'
      } else {
        this.passwordMessage = ''
      }
    },
    passwordInput() {
      //console.log(this.account.length)
      if (this.pwd) {
        this.passwordMessage = ''
      } else {
      }
    },
    //跳转注册页面
    toRegister() {
      this.$emit('update:showRegister', true)
    },
    //找回密码
    resetPassword() {
      //console.log()
      //登录弹窗独立的vue实例并未挂挂载router
      this.$loginDialog.active = false
      this.$myVue.$router.push('/back-password')
    },
    //腾讯防水墙回调
    callback(res) {
      this.showPlugin = false
      // 回调函数根据 ticket 和 errorCode （而非 ret）的情况做处理
      if (res.ticket) {
        //根据errorCode情况做特殊处理
        if (res.errorCode) {
          //自定义容灾逻辑（例如跳过这次验证） 比如连续错误三次 刷新连续三次
        } else if (res.ret == 2 && !res.ticket) {
          //用户手动关闭
        } else {
          //验证成功
          //可以发送账号密码
          const {ticket, randstr} = res
          this.toLogin(ticket, randstr)
        }
      }
    },
    //显示弹窗前的校验逻辑
    judgeFunction() {
      if (!this.password) {
        this.passwordMessage = '请输入密码'
      }
      if (!this.account) {
        this.accountMessage = '请输入账号'
      }
      if (this.password && this.account) {
        if (!this.isAccept) {
          this.$emit('update:isShowInfor', true)
          setTimeout(() => {
            this.$emit('update:isShowInfor', false)
          }, 2000)
          return
        }
        this.showPlugin = true
      }
    },

    //登录
    toLogin(ticket, randstr) {
      if (!this.isAccept) {
        this.$emit('update:isShowInfor', true)
        setTimeout(() => {
          this.$emit('update:isShowInfor', false)
        }, 2000)
        return
      }
      let data = {
        clientId: '1',
        clientSecret: '123456',
        grantType: 'password',
        tenantId: '0',
        username: this.account,
        password: this.password,
        ticket,
        randStr: randstr
      }
      passwordLogin(data)
        .then(res => {
          //console.log(res);
          if (res.code == 200) {
            let data = res.data
            store.commit('login/setValue', [data.access_token, 'access_token'])
            store.commit('login/setValue', [data.refresh_token, 'refresh_token'])
            store.commit('login/setValue', [data.token_type, 'token_type'])
            store.commit('login/setValue', [true, 'is_login'])
            store.commit('login/setValue', [data, 'userInfor'])
            this.$emit('update:loginScuess', true)
          }
        })
        .catch(err => {
          console.log(err)
          this.passwordMessage = err.errorMsg
        })
    }
  },
  // computed: {
  //   //缓存上一次密码
  //   oldPwd() {
  //     return JSON.parse(JSON.stringify(this.pwd))
  //   }
  // },
  watch: {
    // oldPwd: {
    //   handler(val, oldV) {
    //     //监听登录的密码输入框，将密文显示为*
    //     this.pwd = this.pwd.replace(/./g, '*')
    //     if (oldV.length > val.length) {
    //       //进行删除操作   this.form.password就是定义在data中用来存实际密码的变量
    //       this.password = this.password.substring(0, this.password.length - (oldV.length - val.length))
    //     } else {
    //       this.password += val.replace(/\s+/g, '').replace(/[*]/g, '')
    //     }
    //   },
    //   deep: true
    // },
    account: {
      handler(val, oldV) {
        this.account = this.account.replace(/\s+/g, '')
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.password-type {
  margin-top: 40px;
  .input-item1 {
    height: 58px;
    .account {
      width: 100%;
      height: 39px;
      border-radius: 4px;
      border: 1px solid #5b6189;
      display: block;
      background: rgba(11, 25, 66, 0.9);
      color: #ffffff;
      line-height: 39px;
      padding: 10px 16px 9px;
      box-sizing: border-box;
      &:focus {
        outline: none; //这个可以把原来的线去掉
        border: 1px solid #ddd;
      }
      &.error {
        border: 1px solid #ff564d;
      }
    }
    .bottom-tip {
      width: 200%;
      height: 38px;
      line-height: 38px;
      color: #ff564d;
      font-size: 20px;
      transform: scale(0.5);
      position: relative;
      top: -9.5px;
      left: -50%;
    }
  }

  .input-item2 {
    height: 68px;
    position: relative;
    .account {
      width: 100%;
      height: 39px;
      border-radius: 4px;
      border: 1px solid #5b6189;
      display: block;
      background: rgba(11, 25, 66, 0.9);
      color: #ffffff;
      line-height: 39px;
      padding: 10px 16px 9px;
      box-sizing: border-box;
      &:focus {
        outline: none; //这个可以把原来的线去掉
        border: 1px solid #ddd;
      }
      &.error {
        border: 1px solid #ff564d;
      }
    }
    .bottom-tip {
      width: 200%;
      height: 58px;
      line-height: 58px;
      color: #ff564d;
      font-size: 20px;
      transform: scale(0.5);
      position: relative;
      top: -14.5px;
      left: -50%;
    }
    .reset-password {
      position: absolute;
      right: 0;
      bottom: 6px;
      cursor: pointer;
      color: #82ebff;
      line-height: 16px;
      font-size: 11px;
    }
  }
  .login {
    height: 39px;
    background: #00d2fa;
    border-radius: 4px;
    line-height: 39px;
    text-align: center;
    font-weight: bold;
    color: #ffffff;
    font-size: 13px;
    cursor: pointer;
  }
  .register {
    margin-top: 13px;
    height: 16px;
    color: #82ebff;
    line-height: 16px;
    font-size: 11px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      cursor: pointer;
    }
  }
}

.user-infor {
  position: relative;
  padding: 13px 0px 13px 21px;
  box-sizing: border-box;
  .check-box {
    width: 10px;
    height: 10px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #979797;
    position: absolute;
    top: 15px;
    left: 0;
    cursor: pointer;

    &.active {
      background: url('@/assets/image/icon/allScreen.png') no-repeat center;
      background-size: 100%;
      border: none;
    }
  }
  .infor-content {
    p {
      height: 16px;
      line-height: 16px;
      font-size: 11px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}

.jg {
  height: 1px;
  background: #82889a;
  opacity: 0.2;
  margin-top: 20px;
}
a {
  text-decoration: none;
}

a:hover,
a:visited,
a:link,
a:active {
  // 做到只设置一次，就可以使所有a标签的四种状态都和本身颜色保持一致，样式代码该怎么写
  color: #82ebff;
  cursor: pointer;
}
.heightLight {
  color: #82ebff;
  cursor: pointer;
}
</style>
